/**
 * RESPONSIBILITY: the one-line link to this week's bulletin, under the home page's welcome.
 *
 * A text link and not a second button: "Plan your visit" is the card's one action for a
 * newcomer, and the bulletin is for the people already in the pew. It names the Sunday in
 * the file's name, and says "this week's" only when that is the coming Sunday.
 *
 * Opens in a new tab: a phone hands a PDF to its own viewer, with zoom, and the site is
 * still there behind it afterwards.
 */
import type { BulletinSection } from '@app/sections';
import { useBulletins, isThisWeeks, bulletinHref } from './useBulletins';
import { bulletinDay } from './bulletin-day';

export function BulletinLink({ c }: { c: BulletinSection }) {
  const [latest] = useBulletins(c.folderUrl);
  if (!latest) return null;
  const label = isThisWeeks(latest) ? c.homeLabel : c.latestLabel;
  if (!label) return null;

  return (
    <a className="bulletin-link" href={bulletinHref(latest)} target="_blank" rel="noopener">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
           strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5M9 13h6M9 17h6" />
      </svg>
      <span>{label}{latest.date && <span className="bulletin-link-date"> · {bulletinDay(latest.date, true)}</span>}</span>
    </a>
  );
}
